import { render } from "./FooterCopyright.vue?vue&type=template&id=5186c35d"
import script from "./FooterCopyright.vue?vue&type=script&lang=js"
export * from "./FooterCopyright.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\skyle\\source\\repos\\skylab\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__